import axios from "@/utils/request";

export function login(data) {
  return axios({
    url: "/signin",
    method: "post",
    data,
  });
}
